<i18n lang="yaml">
  pt:
    hello: "Olá"
    user-content: "Conteúdo do usuário"
    access-your-account: "Acesse sua conta"
</i18n>

<template>
  <div class="userapp w-100">
    <div
      data-grid
      class="userapp__wrapper grid--va-center"
    >
      <a
        :href="`${connectURL}/profile?product=checkout`"
        target="_blank"
        data-grid="center-center"
        class="userapp__icon cursor-pointer"
      >
        <UserIcon />
      </a>

      <a
        target="_blank"
        class="userapp__info"
        :href="`${connectURL}/profile?product=checkout`"
      >
        <span class="userapp__info-name d-block">
          <strong class="hi">{{ $t('hello') }},</strong> <strong>{{ name }}</strong>
        </span>

        <small class="userapp__info-message">
          {{ $t('access-your-account') }}
        </small>
      </a>

      <div
        class="userapp__options--close w-100 h-100 d-none p-fixed"
        @click="toggleUserOptions()"
      />

      <figure
        class="userapp__usericon p-relative has-tooltip"
      >
        <span
          class="icon-click cursor-pointer"
          @click="toggleUserOptions()"
        >
          <ArrowDownIcon />
        </span>

        <div
          data-grid="column"
          class="inc-options-container"
        >
          <UserNavigation />
        </div>
      </figure>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

import UserNavigation from './UserNavigation.vue'
import ArrowDownIcon from './../../../icons/ArrowDownIcon'
import UserIcon from './../../../icons/UserIcon'

export default defineComponent({
  name: 'UserApp',

  components: {
    UserIcon,
    ArrowDownIcon,
    UserNavigation
  },

  computed: {
    connectURL () {
      return process.env.VUE_APP_INCREAZY_CONNECT
    },

    name () {
      let name = ''
      let lastname = ''

      if ((this.$user?.name || '').includes(' ')) {
        name = this.$user.name.split(' ')[0]
        lastname = this.$user.name.split(' ')[1]
      } else {
        name = this.$user?.name || ''
        lastname = ''
      }

      return `${name} ${lastname[0] || ''}`
    }
  },

  methods: {
    toggleUserOptions () {
      const options = document.querySelector('.userapp .inc-options-container')
      const close = document.querySelector('.userapp .userapp__options--close')
      if (options) {
        options.classList.toggle('active')
        close.classList.toggle('active')
      }
    }
  }
})
</script>

<style scoped lang="scss">
  .userapp {
    max-width: 355px;

    &__icon {
      width: 40px;
      height: 40px;
      min-height: auto;
      margin-right: 16px;
      border-radius: 50%;
      background-color: rgb(var(--white));

      .is-dark-theme & {
        background-color: rgb(var(--black1));

        svg {
          stroke: rgb(var(--gray4));
        }
      }

      svg {
        width: 20px;
        stroke: var(--primary);
      }
    }

    &__info {
      color: var(--primary-dark);

      .is-dark-theme & {
        color: rgb(var(--gray4));
      }

      &-name,
      &-message {
        font: normal var(--weight) var(--size) / var(--height) "Nunito", sans-serif;
      }

      &-name {
        --weight: 400;
        --size: 1.6rem;
        --height: 1.375;

        .hi {
          color: rgb(var(--white));
          font-weight: 400;
        }
      }

      &-message {
        --weight: 400;
        --size: 1.3rem;
        --height: 1.38;
        text-decoration: underline;
      }
    }

    &__usericon {
      color: var(--primary-dark);

      .is-dark-theme & {
        color: rgb(var(--gray4));
      }
    }

    &__options--close {
      z-index: 9;
      top: 0;
      left: 0;
      background: transparent;

      &.active {
        display: block !important
      }
    }

    &__usericon {
      z-index: 10;
      margin: 0 0 0 21px;

      .icon-click svg {
        width: 12px;
      }
    }

    @media (max-width: 1024px) {
      width: auto;
      margin-inline: 8px 0;

      &__icon {
        margin: 0;
      }

      &__usericon,
      &__icon + a{
        display: none;
      }
    }
  }
</style>
